import data from './deriveProductFromProductSku.json';

/**
 * Derives the product name from the given product SKU.
 *
 * @param {string} productSku - The SKU of the product.
 * @returns {string | null} The name of the product, or undefined if the SKU is not found.
 */

function deriveProductFromProductSku(productSku) {
  const productName = data[productSku];

  if (!productName) {
    console.error(
      `Web.Zephr:deriveProductFromProductSku:error: no product mapping found for productSku "${productSku}". Please check that the productSku is configured correctly in Zephr Console.`,
    );

    return null;
  }

  return productName;
}

export default deriveProductFromProductSku;
